// extracted by mini-css-extract-plugin
var _1 = "EmailProfileMessageBodyAttachedFilesSkeleton-moduleEmailProfileMessageBodyAttachedFilesSkeleton__rAiBx";
var _2 = "EmailProfileMessageBodyAttachedFilesSkeleton-moduledownloadAllButton__bWQsq Skeleton-moduleSkeleton__Mlrfv";
var _3 = "EmailProfileMessageBodyAttachedFilesSkeleton-modulefileList__wsfBc";
var _4 = "EmailProfileMessageBodyAttachedFilesSkeleton-moduleheader__grkqT";
var _5 = "EmailProfileMessageBodyAttachedFilesSkeleton-moduletitle__dYnPu Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "EmailProfileMessageBodyAttachedFilesSkeleton", _2 as "downloadAllButton", _3 as "fileList", _4 as "header", _5 as "title" }
